import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ImageAnimation } from "../../shared/components/ImageAnimation/ImageAnimation";
import classes from "./About.module.scss";

export const About: FC = () => {
	const { t } = useTranslation();

	return (
		<div className={classes.wrapper}>
			<ImageAnimation />

			<div className={classes.content}>
				<h3 className={classes.title}>{t("translation.about.title")}</h3>
				<span className={classes.text}>{t("translation.about.text")}</span>
			</div>
		</div>
	);
};
